export default __webpack_public_path__ + "static/media/aleksandar_s.418172b9.jpg";